export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Procesos de Exportación"])}
        }
      },
      "en": {
        "labels": {
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Export Processes"])}
        }
      }
    }
  })
}